/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'
import { BaseApiParams, BaseApiResponse } from '@/typings/common'
import isNil from 'lodash/isNil'

export class MarksProceduresApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'procedures';

  protected readonly hasFinishSlash = false;

  public createProcedure(p: BaseApiParams, config?: AxiosRequestConfig) {
    const path = 'create'

    const data = new FormData()
    Object.entries(p).forEach(([k, v]) => {
      if (!isNil(v)) data.append(k, v as string | Blob)
    })
    const [url] = this.getUrl(path, p)
    return this.request<never, BaseApiResponse<Data>>('POST', url, { data, ...config })
  }
}
